import { compose } from 'redux';
import { connect } from 'react-redux';
import { updateKeywordFilterValue as updateKeywordFilterValueAction } from '@Containers/ResultsFilters/ResultsFiltersComponents/FullTextFilter/FullTextFilterActions';
import FullTextFilter from './FullTextFilter';

const mapDispatchToProps = {
  updateKeywordFilterValue: updateKeywordFilterValueAction,
};

export default compose(connect(null, mapDispatchToProps))(FullTextFilter);
